"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlumbingMaterialTypesFlags = void 0;
var enums_1 = require("../../enums");
var FlaggedEnum_1 = require("../FlaggedEnum");
exports.PlumbingMaterialTypesFlags = FlaggedEnum_1.FlaggedEnum.create(enums_1.PlumbingMaterialType, 1 << 13);
//# sourceMappingURL=PlumbingMaterialTypes.js.map